import {
  getFirstAttributeValue,
  type Product,
  type Variant,
} from '@scayle/storefront-nuxt'

export {}

declare global {
  type VariantWithProduct = Variant & { product: Product }
}

export function getSizeLabel(variant: Variant) {
  const attributes = variant?.attributes
  const categorySize = getFirstAttributeValue(attributes, 'sizeCategorySize')
  const label = categorySize?.label.split('|')[1]

  if (label) return label

  const sizeAttribute = getFirstAttributeValue(attributes, 'size')?.value
  return sizeAttribute
    ? 'EU' + sizeAttribute
    : ''
}
